import { call, put, takeEvery } from 'redux-saga/effects';
import { AddCartItem, CartsActionKeys } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { cartsActionCreators } from '../cartsActionCreators';
import * as api from '../cartsApi';
import { ICartLineUpdateResponse } from '../cartsInterfaces';

function* addCartItemSaga(action: AddCartItem) {
  yield put(cartsActionCreators.toggleSavingCartLine(action.payload));
  const response: IApiExecuteRespone<ICartLineUpdateResponse> = yield call(api.addCartItem, action.payload);

  if (!response.requestFailed && response.value) {
    if (response.value) {
      yield put(cartsActionCreators.setUpdatedCartLine(response.value));
    }
  } else {
    yield showFailedRequestDialog(response);
  }

  yield put(cartsActionCreators.toggleSavingCartLine(action.payload));
}

export function* watchAddCartItemSaga() {
  yield takeEvery(CartsActionKeys.ADD_CART_ITEM, addCartItemSaga);
}
